import styled from '@emotion/styled';
import { ComponentWrapper } from '@/components/component-wrapper';

export const TermsAndConditions = styled(ComponentWrapper)`
  a {
    color: var(--a-link-color);
    text-decoration: var(--link-text-decoration);
  }
`;
